import React, { useEffect, useState } from 'react';
import { Row, Col, Slider, InputNumber, Modal } from 'antd';

export default function CountDivider({ open, onOK, onCancel, dragDropResults, planningData }) {
    const planningDataId = dragDropResults?.draggableId;
    const planningItem = planningData?.find(item => item.id == planningDataId);
    const maxCount = planningItem?.data?.length || 1;

    const [inputValue, setInputValue] = useState(maxCount);

    useEffect(() => {
        setInputValue(maxCount);
    }, [maxCount, planningDataId]);

    const handleOk = () => {
        const count = Number(inputValue);
        if (!count || count < 1) return;
        onOK(Math.min(count, maxCount));
    };

    return (
        <Modal
            title="Select the count you wish to add to the bay"
            open={open}
            onOk={handleOk}
            onCancel={onCancel}
            okButtonProps={{ disabled: !planningItem }}
            getContainer={() => document.body}
            zIndex={2000}
            destroyOnClose
        >
            <p style={{ marginBottom: 16 }}>{`Available EANs: ${planningItem?.data?.length ?? 0}`}</p>
            <Row gutter={12} align="middle">
                <Col span={16}>
                    <Slider min={1} max={maxCount} onChange={setInputValue} value={inputValue} />
                </Col>
                <Col span={8}>
                    <InputNumber min={1} max={maxCount} value={inputValue} onChange={setInputValue} style={{ width: '100%' }} />
                </Col>
            </Row>
        </Modal>
    );
}
